import React, {useState} from "react";
import {app_singleton} from "../../utility/app_singleton";
import {DialogActions} from "@material-ui/core";
import {DialogContent, Typography} from "@mui/material";

import LoadingPopup, {loading} from "./loading_popup";
type LoadingComponent = loading.LoadingComponent;
type IMessage = loading.IMessage;
type ILoadingPopupMessageState = loading.ILoadingPopupMessageState;

interface State {
    loading: boolean,
    type: "success" | "error",
    data?: ILoadingPopupMessageState
}

export class MessageComponent implements loading.ILoadingStrategy {

    private state: State

    constructor(
        public obj: app_singleton.loading_popup_data,
        private loading_component: LoadingComponent,
        private father: LoadingPopup,
        private post: IMessage
    ) {

        this.state = {
            loading: true,
            type: "success"
        }

        this.init()
    }

    setState = (new_state: State) => {
        this.state = new_state;
        this.father.setState({});
    }

    init(){
        const {obj, post} = this
        const close = this.father.close

        obj.promise.then((data) => {
            this.setState({
                loading: false,
                type: "success",
                data: post.success(data, close)
            })
        })
            .catch((err) => {
                this.setState({
                    loading: false,
                    type: "error",
                    data: post.error(err, close)
                })
            })
    }

    handle_close = () => {
        if(this.state.loading)
            return;
        this.father.close();
    }

    render() {
        const state = this.state;

        if (state.loading || state.data === undefined)
            return this.loading_component.render();

        const data = state.data;
        const img_url = state.type === "success" ? "/icon/success-check.svg" : "/icon/error-check.svg";

        return (
            <>
                <DialogContent>
                    <div style={{width: 100, height: 100, margin: "auto"}}>
                        <img style={{width: "100%", height: "100%"}} src={img_url}/>
                    </div>
                    <Typography>
                        {data.text}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    {data.button?.render()}
                </DialogActions>
            </>
        )
    }
}